import "./style.scss";

import { CircularProgress } from "@mui/material";
import { Box } from "@mui/system";
import AlertTriangle from "assets/img/svg/alertTriangle";
import MessageBlock from "components/shared/MessageBlock";
import StyledButton from "components/shared/StyledButton";
import StyledTextField from "components/shared/StyledTextField/StyledTextField";
import { IHandleRequest } from "hooks/useAPIPagination";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { fetchWithheldBeneficiaryPercentage } from "store/beneficiaryStore";
import type { ITermBeneficiar } from "store/managementStore";
import { fetchStats } from "store/managementStore";
import { useAppDispatch, useAppSelector } from "store/store";
import { BeneficiaryVAT } from "store/types";

import variables from "../../../../../assets/styles/_variables.module.scss";

type TProps = {
    beneficiary: ITermBeneficiar;
};
const WithheldModal = ({ beneficiary }: TProps) => {
    const [t] = useTranslation();
    const navigate = useNavigate();
    const { withheldPercentageStatus } = useAppSelector((state) => state.beneficiary);

    if (withheldPercentageStatus === "pending") {
        return (
            <Box
                sx={{
                    width: "100%",
                    textAlign: "center",
                }}
            >
                <CircularProgress sx={{ color: variables["primary-purple"] }} />
            </Box>
        );
    }

    // Shouldn't it only be vat check? This was what existed before...
    const beneficiaryNotConcerned = beneficiary.precount != 0 || beneficiary.vat != BeneficiaryVAT.FRANCHISE;

    return (
        <>
            <div className="add-withheld-grossduty">
                {beneficiaryNotConcerned ? (
                    <Box
                        sx={{
                            width: "100%",
                            textAlign: "left",
                        }}
                    >
                        <MessageBlock type="error" text={t("Management.CannotWithheldGrossDuty")} />
                    </Box>
                ) : (
                    <div className="new-placement-info">
                        <span>{t("Management.WithheldPercent.TextNavigate1")}</span>
                        <span>{t("Management.WithheldPercent.TextNavigate2")}</span>
                    </div>
                )}

                <StyledButton
                    buttonType="primary"
                    fullWidth
                    disabled={beneficiaryNotConcerned}
                    onClick={() => navigate(`/beneficiars/${beneficiary.id}`)}
                >
                    {t("Management.WithheldPercent.GoToBeneficiary")}
                </StyledButton>
            </div>
        </>
    );
};

export default WithheldModal;
